import { Navigate } from 'react-router';

import { MembershipsViewContainer, AddMemberAction } from 'src/containers/Escrow/Memberships';
import { useSoftwareEscrow } from 'src/context/software-escrow';

const SoftwareEscrowMembers = () => {
  const {
    softwareEscrow: { status, beneficiary, escrowInvitation, app },
  } = useSoftwareEscrow();

  if (app.owned) return <Navigate to="../overview" relative="path" replace />;

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-start gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between sm:gap-2">
        <div className="space-y-1">
          <h2 className="font-semibold text-base text-gray-700">Escrow members</h2>
          <p className="text-sm text-muted-foreground">
            The team members who have access to this escrow, and their respective permissions.
          </p>
        </div>
        <AddMemberAction
          beneficiaryId={beneficiary!.id}
          canAdd={beneficiary!.policy.createEscrowMemberships}
          escrowInvitationStatus={escrowInvitation?.status}
          escrowStatus={status}
        />
      </div>
      <MembershipsViewContainer beneficiaryId={beneficiary!.id} escrowInvitationStatus={escrowInvitation?.status} />
    </div>
  );
};

export default SoftwareEscrowMembers;
